module.exports = __webpack_public_path__ + "img/account_ledger.247b6720.svg";